// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__2vt8F","warning":"Settings_warning__3yncG","warningSetting":"Settings_warningSetting__3-yt4","warningButton":"Settings_warningButton__lpiBW"};